import { render, staticRenderFns } from "./chTopNav.vue?vue&type=template&id=5a2c75e0&scoped=true&"
import script from "./chTopNav.vue?vue&type=script&lang=js&"
export * from "./chTopNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2c75e0",
  null
  
)

export default component.exports